import React, { useState, useEffect, useRef } from "react";
import ColorDropdown from "../../../Dropdown/ColorDropdown";
import BasicSelect from "../../../Task/BasicSelect";
import { ReactComponent as CrossIconAdvancedFilter } from "../../../../assets/images/crossIconAdvancedFilter.svg";
import { ReactComponent as Addtag } from "../../../../assets/images/icons/Addtag.svg";
import withPortalHOC from "../../../UniversalComponents/WithPortalHOC";
import List from "../../../UniversalComponents/ListComponent";
import { TagOptionsColored } from "../../../../utils/utilityFunctions/stringUtility";
import { useFetchNoteTagsQuery } from "../../../../utils/customer/customerSelect";
import { createOption } from "../../../../utils/api/customTemplatesApi";
import { pushAlert } from "../../../../utils/alertSlice";
import { useDispatch } from "react-redux";

const PortalList = withPortalHOC(List);

const CustomerNameViewNotes = ({
  handleNotesClick,
  children,
  colourCodes,
  customerTaskCategory,
  customerColor,
  handleSubmit,
  handleInputChange,
  handleSetColour,
  formData,
  setAddNotes,
  handleEditNote,
  addNotes,
  notesData,
  setFormData,
  listOpen = false,
  selectedOptions,
  setSelectedOptions,
  handleOptionClick,
}) => {
  const formRef = useRef(null);
  const handleInsertColur = (color) => {
    handleSetColour(color);
  };
  const dropdownRef = useRef();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(listOpen);
  const [tagsList, setTagsList] = useState(null);
  const [fieldName, setFieldName] = useState(null);

  const {
    data: allNotesTagsList,
    isError: isNotesTagsListError,
    isSuccess: isNotesTagsListSuccess,
    error: notesTagsListError,
    isLoading: isNotesTagsListLoading,
    refetch: refetchNotesTagsList,
  } = useFetchNoteTagsQuery();

  useEffect(() => {
    if (isNotesTagsListSuccess && allNotesTagsList?.data?.length) {
      setTagsList(allNotesTagsList?.data);
      setFieldName(allNotesTagsList?.field_name);
    }
  }, [isNotesTagsListSuccess, isNotesTagsListError, notesTagsListError, allNotesTagsList?.data]);

  useEffect(() => {
    if (customerTaskCategory?.data?.notes?.length && !notesData[0]?.category_name) {
      handleInputChange({
        target: {
          name: "notes_category_id",
          value: customerTaskCategory.data.notes[0].id,
        },
      });
    }
  }, [customerTaskCategory]);

  const ClearFormdata = () => {
    setFormData({ notes_title: "", notes_category_id: "", colour_code: "" });
  };

  const toggleTagDropdown = (e) => {
    // if (clickTrigger && !isOpen) clickTrigger();
    // console.log(clickTrigger, "clickTrigger");

    // if (isOpen && !multiSelect) listCloseHandler();
    console.log("taregetValue", e.target, dropdownRef);
    // if(e.target?.datatype === dropdownRef?.datatype)
    setIsOpen((prev) => !prev);
  };

  const handleFieldOptionAdd = async (optionData, OldOtion) => {
    try {
      let body = {
        value: optionData.value,

        ...(OldOtion?.id && { id: OldOtion?.id }),
      };

      if (optionData?.color_code) {
        body = {
          value: optionData?.value,
          color: optionData?.color_code,

          ...(OldOtion?.id && { id: OldOtion.id }),
        };
      }
      const response = await createOption({ query: { field_name: fieldName }, body });

      if (response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );
        refetchNotesTagsList();
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  return (
    <form onSubmit={handleSubmit} ref={formRef} className="w-full h-[70vh]">
      <div className="w-full h-full flex flex-col items-start justify-center">
        <div className="w-full flex items-center justify-between py-3 px-5">
          <span className="text-[#666]">{addNotes === "new" ? "Add Notes" : notesData[0]?.customer_name}</span>

          <button
            onClick={() => {
              ClearFormdata();
              setAddNotes(false);
            }}
          >
            <CrossIconAdvancedFilter />
          </button>
        </div>

        <div className="border min-h-0 grow w-full flex flex-col items-start justify-between p-4 ">
          <div className={`flex flex-row w-full border rounded-t-md bg-[#F6F6F6] border-DDE1E3 items-center`}>
            <div className="flex items-centre justify-center gap-x-1 flex-grow bg-[#F6F6F6]">
              <span className="w-full flex items-center justify-center">
                <input
                  type="text"
                  placeholder="Title  :"
                  className="w-full border bg-[#F6F6F6] rounded-[5px] focus:ring-0 border-transparent focus:border-[#778FA5] "
                  //onClick={() => handleNotesClick("addnotes")}
                  onChange={handleInputChange}
                  name="notes_title"
                  value={formData?.notes_title || ""}
                />
              </span>

              <div className="flex relative gap-2 items-center cursor-pointer mx-2" datatype="tags">
                <Addtag />
                <span
                  className="text-[#666]  font-normal text-sm whitespace-nowrap"
                  onClick={(e) => toggleTagDropdown(e)}
                  ref={dropdownRef}
                >
                  Add Tag
                </span>
                {isOpen && (
                  <PortalList
                    containerRef={dropdownRef}
                    open={isOpen}
                    xAxis={-150}
                    yAxis={18}
                    onClose={() => {
                      setIsOpen(false);
                    }}
                    //
                    options={tagsList}
                    showSearch
                    multiSelect
                    // isTagList
                    addButton
                    valueKey="id"
                    // addButtonLabel="Add New Tag"
                    isEditList
                    addButtonAction={(val) => handleFieldOptionAdd(val)}
                    editListHandler={(val, val2) => handleFieldOptionAdd(val2, val)}
                    inlineCrud
                    size={"medium"}
                    selectedOptions={selectedOptions}
                    // setSelectedOptions={setSelectedOptions}
                    onOptionClick={handleOptionClick}
                  />
                )}
              </div>
            </div>

            <div className="border-l h-full bg-[#F6F6F6] border-gray-300 flex items-center rounded-sm px-3 ">
              <span className="py-2 px-1 relative">
                <ColorDropdown
                  colors={customerColor}
                  handleInsertColur={handleInsertColur}
                  onChange={handleInputChange}
                  colourCodes={formData?.colour_code || colourCodes}
                  isSideDrawer
                />
              </span>
            </div>
          </div>
          {children}
        </div>
      </div>
    </form>
  );
};

export default CustomerNameViewNotes;
